import { environment } from 'src/environments/environment';

export const base_url = environment.STESSA_API_URL;
export const user_profile = '/user/get-current-user';
export const filteredData = '/';
export const get_user_by_email = '/user/get-user-by-email';
export const getUserById = `${base_url}/user/userId`;
export const getSoftwareList = `${base_url}/public/get-software-list`;
export const healthCheck = `${base_url}/health-check`;
export const recoveryNotes = `${base_url}/recovery-note`;
